<template>
    <div class="editor-row customize-editor-minimize data-items">
        <div class="editor-row-title">{{ $t('auto.stringFormatterDefaultDefaultValue') }}</div>
        <TiptapEditor
            placeholder="Input Text"
            :show-attributes="true"
            v-model="clone.default.value"
            :show-emoji="false"
            automation-mode
        />
        <small class="description">
            {{ $t('auto.stringFormatterDefaultJSONPathGetMoreInfoFrom') }} <a href="https://goessner.net/articles/JsonPath/" target="_blank">here</a>
        </small>
    </div>
</template>

<script>
import log2 from "../../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";

const log = log2("StringFormatterDefault");
export default {
    name: "StringFormatterDefault",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "string.capitalize",
            value: "",
            regex: {
                pattern: "",
                flags: "",
                matchAll: false,
            },
            find: {
                skip: "0",
                pattern: "",
            },
            split: {
                delimiter: " ",
                take: "0",
            },
            truncate: {
                maxLength: "0",
                skipChars: "0",
                appendEllipsis: false,
            },
            default: {
                value: "",
            },
        };
        return {
            clone,
        };
    },
    methods: {},
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss"></style>
